var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basket"},[_c('ul',{staticClass:"list"},_vm._l((_vm.applesInBasket),function(apple){return _c('li',{key:apple.name,staticClass:"apple"})}))])}
var staticRenderFns = []

export { render, staticRenderFns }